export default __webpack_public_path__ + "static/media/Group17523.c41d88cb.svg";